module.exports = __webpack_public_path__ + "img/moren.94402a56.jpg";